import {Injectable} from "@angular/core";
/**
 * Created by greg on 2/06/2018.
 */

@Injectable()
export class TaxService {
    public schedule = {
        'AU':{
            has_sales_tax:true,
            name:'GST',
            in_summary:'10% GST',
            in_panel:'ex. GST',
            calc:this.australiaCalculate
        }
    }
    australiaCalculate(cost:number){
        return Math.round(100 * ((cost * 1.1) - cost))/100;
    }
    australiaReverseCalculate(cost:number){
        return Math.round(100 * (cost - (cost/11*10)))/100;
    }
}


// WEBPACK FOOTER //
// ./src/app/payment/taxes.service.ts